<template lang="pug">
  .hook-error
    .section
      .container
        .columns
          .column
            .block-center
              h2 {{ gettext('Error!') }}
              h3 {{ gettext('An error occurred while verifying email, contact with support, or try again later.') }}
              .field
                .field-body
                  router-link.main-btn.col-white.bg-red(:to="`/${getLanguage}/`") {{ gettext('Go to the main page') }}
</template>

<script>
import { gettext } from '@/services/TranslateHandler'
import { mapGetters } from 'vuex'

export default {
  name: 'ActivateAccountConfirmation',
  beforeRouteEnter (to, from, next) {
    if (to.query.success === '1') {
      next(vm => {
        vm.$router.push({name: 'Login', params: { lang: vm.getLanguage }, query: {restoredAccount: true}})
      })
    }
    next()
  },
  methods: {
    gettext: gettext
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ])
  }
}
</script>

<style scoped lang="scss" src="./styles.scss"></style>



// WEBPACK FOOTER //
// src/pages/hooks/activate-account-confirmation/index.vue